<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="content">
        <h1>Fogalomtár és rövidítések</h1>
        <GlossarySearchBar
          :searchRoute="'glossary'"
          :placeholder="'Keressen a fogalmak és rövidések között'">
        </GlossarySearchBar>
      </div>

      <div v-if="filteredGlossaryAndConceptItems.length">
        <div class="content">
          <h3>Találatok</h3>
        </div>

        <div class="columns is-multiline">
          <div class="column is-3-desktop is-4-tablet is-12-mobile"
               v-for="filteredGlossaryAndConceptItem in filteredGlossaryAndConceptItems"
               :key="filteredGlossaryAndConceptItem.sys.id + '-filtered'">
              <GlossaryAndConceptCard
                :glossaryAndConceptItem="filteredGlossaryAndConceptItem"
                :marked="true"
              ></GlossaryAndConceptCard>
          </div>
        </div>

        <div class="content">
          <h3>Összes fogalom és rövidítés</h3>
        </div>
      </div>

      <div class="columns is-multiline">
        <div class="column is-3-desktop is-4-tablet is-12-mobile"
             v-for="glossaryAndConceptItem in glossaryAndConceptItems"
             :key="glossaryAndConceptItem.sys.id">
          <GlossaryAndConceptCard :glossaryAndConceptItem="glossaryAndConceptItem"></GlossaryAndConceptCard>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  /* Services */
  import Contentful from '@/services/Contentful'

  /* Components */
  import GlossarySearchBar from '@/components/General/SearchBar'
  import GlossaryAndConceptCard from '@/components/General/GlossaryAndConceptCard'
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        glossaryAndConceptItems: [],
        filteredGlossaryAndConceptItems: [],
        isLoading: true
      }
    },
    async mounted () {
      /* Get concepts and glossary items, sort by name */
      let glossaryItems = (await Contentful.getAllEntriesByContentType('glossary')).data.items || []
      let concepts = (await Contentful.getAllEntriesByContentType('concept')).data.items || []
      this.glossaryAndConceptItems = glossaryItems.concat(concepts)
      /* Filter */
      this.glossaryAndConceptItems = this.glossaryAndConceptItems.filter((item) => {
        return (item.fields.isVisibleOnGlossaryPage !== false)
      })
      /* Sort */
      this.glossaryAndConceptItems = this.glossaryAndConceptItems.sort((a, b) => {
        if ((a.fields.name || '').toLowerCase() < (b.fields.name || '').toLowerCase()) { return -1 }
        if ((a.fields.name || '').toLowerCase() > (b.fields.name || '').toLowerCase()) { return 1 }
        return 0
      })
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    },
    watch: {
      '$route.query.q': {
        immediate: true,
        async handler (queryString) {
          let filteredGlossaryItems = (await Contentful.getAllEntriesByContentTypeAndQuery('glossary', queryString)).data.items || []
          let filteredConcepts = (await Contentful.getAllEntriesByContentTypeAndQuery('concept', queryString)).data.items || []
          this.filteredGlossaryAndConceptItems = filteredGlossaryItems.concat(filteredConcepts)
        }
      }
    },
    components: {
      GlossarySearchBar,
      GlossaryAndConceptCard,
      Loader
    }
  }
</script>

<style scoped>
  .column {
    display: flex;
  }
</style>




// WEBPACK FOOTER //
// src/components/Pages/Glossary.vue